/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'mobile-menu-links.scss' instead.
import { css } from 'lit';
export default css `:host a{font-weight:var(--cipublic-font-weight-normal)!important}:host a:not(:active):not(:focus):not(:hover){border:0!important}`;
//# sourceMappingURL=mobile-menu-links.scss.js.map